var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "button",
    {
      staticClass: "button gray sm",
      on: {
        click: function ($event) {
          $event.preventDefault()
          return _vm.openPopup.apply(null, arguments)
        },
      },
    },
    [_vm._v(_vm._s(_vm.$t("comp.200")))]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }